const INIT_PARTNER = 'partner/INIT_PARTNER';
const UPDATE_PARTNER = 'partner/UPDATE_PARTNER';
const defaultState = { settings: {} };

export default function reducer(state = defaultState, { type, payload }) {
    switch (type) {
        case INIT_PARTNER:
            return { ...payload };
        case UPDATE_PARTNER:
            return {
                ...state,
                ...payload,
                thirdParty: {
                    ...state.thirdParty,
                    ...(Boolean(payload.thirdParty)
                        ? Object.keys(payload.thirdParty).reduce((acc, key) => {
                              acc[key] = {
                                  ...state?.thirdParty?.[key],
                                  ...payload?.thirdParty?.[key]
                              };
                              return acc;
                          }, {})
                        : {})
                }
            };
        default:
            return state;
    }
}

export function initPartner(data) {
    return {
        type: INIT_PARTNER,
        payload: data
    };
}

export function updatePartnerDataWithNoFetch(data) {
    return {
        type: UPDATE_PARTNER,
        payload: data
    };
}
